import React, { useEffect, useState } from 'react';
import { Button, Checkbox, Col, DatePicker, Form, Input, InputNumber, Row, Select, Table, Tabs, Tooltip, message } from 'antd';
import { Link, useLoaderData, useNavigate, useOutletContext, useParams } from 'react-router-dom';
import { FaCloudArrowUp } from 'react-icons/fa6';
import EventEmitter from '../utils/eventEmitter';
import { Badge } from 'flowbite-react';
import useAnalyticItemAPI from '../apis/AnalyticItemAPI';
import dayjs from 'dayjs';




const AnalyticItemChanges = () => {
  const [form] = Form.useForm();
  const { success, error } = useOutletContext();
  const {analyticItem, analytics, accounts } = useLoaderData();
  analyticItem['date'] = analyticItem.date ? dayjs(analyticItem['date'], 'YYYY-MM-DD') : '';
  const params = useParams();
  const navigate = useNavigate();
  const { save } = useAnalyticItemAPI();


  const handleSubmit = async() => {
    let data = form.getFieldsValue();
    data['date'] = new Date(data['date']).toLocaleDateString();
    save(data, success);
    console.log(data)
  }

  const handleUpdate = async() => {
    let data = form.getFieldsValue();
    // update(analytic.seo, data, success);
    // console.log(data)
  }

  useEffect(() => {
    EventEmitter.subscribe('analytic_item_response', data => {
      navigate('/accounting/analytic-items/'+data.replaceAll('/', '-'));
    });
    return () => EventEmitter.unsubscribe('analytic_item_response');
  },[]);

  return (
    <div className='container mx-auto' style={{maxWidth: '900px'}}>
      <div>
        <div className='flex'>
          <h3 className='font-bold'>
            <Link to={'/accounting/analytic-items'} className='whitespace-nowrap hover:underline text-sky-600 dark:text-white'>Analytic Items</Link> / {params.action}
          </h3>
          <Tooltip title={'save manually'} placement='rightBottom' className='ms-1'>
            <Button onClick={handleSubmit} type='text' htmlType='button'
              disabled={ analyticItem.number ? true : false}
              className='border-0 bg-transparent focus:bg-transparent'
              icon={<FaCloudArrowUp />}
            />
          </Tooltip>
        </div>
        {analyticItem.description && <Button onClick={handleUpdate}>UPDATE</Button>}
      </div>
      <div className='mt-5 bg-white p-3 shadow'>
        <Form 
          form={form}
          labelAlign='left'
          labelCol={{span: 9}}
          initialValues={analyticItem.number ? analyticItem :{}}
          variant='borderless'
        >
          <Row>
            <Col md={{span: 10}}>
              <Badge className="text-slate-500 text-xl bg-transparent	border-b-2">Analytic Item</Badge>
              <Form.Item label='Description' name={'description'} className='font-semibold text-gray-800 mb-2 column' required>
                <Input className='border-x-0 border-t-0 w-full text-gray-800 input-outline-none font-normal' />
              </Form.Item>
              <Form.Item label='Analytic Account' name={'analytic_account_id'} className='font-semibold text-gray-800 mb-2 column' required>
                <Select options={analytics.map(account => ({value: account._id, label: account.name}))} className='border-x-0 border-t-0 w-full text-gray-800 input-outline-none font-normal' />
              </Form.Item>
              <Form.Item label='Date' name={'date'} className='font-semibold text-gray-800 mb-2 column' required>
                <DatePicker className='w-full font-normal'/>
              </Form.Item>
            </Col>
            <Col md={{span: 11, offset: 1}}>
              <Badge className="text-slate-500 text-xl bg-transparent border-b-2	">Amount</Badge>
              <Form.Item label='Amount' name={'amount'} className='font-semibold text-gray-800 mb-2 column' required>
                <InputNumber className='border-x-0 border-t-0 w-full text-gray-800 input-outline-none font-normal'/>
              </Form.Item>
              <Form.Item label='Reference' name={'reference'} className='font-semibold text-gray-800 mb-2 column' required>
                <Input type='text' className='border-x-0 border-t-0 w-full text-gray-800 input-outline-none font-normal'/>
              </Form.Item>
              <Form.Item label='Quantity' name={'quantity'} className='font-semibold text-gray-800 mb-2 column' required>
                <InputNumber className='border-x-0 border-t-0 w-full text-gray-800 input-outline-none font-normal'/>
              </Form.Item>
              <Form.Item label='Product' name={'product'} className='font-semibold text-gray-800 mb-2 column' required>
                <Select options={[]} className='border-x-0 border-t-0 w-full text-gray-800 input-outline-none font-normal' style={{width: '200px'}}/>
              </Form.Item>
              <Badge className="text-slate-500 text-xl bg-transparent	border-b-2">Accounting</Badge>
              <Form.Item label='Journal Item' name={'journal_item_number'} className='font-semibold text-gray-800 mb-2 column' required>
                <Select options={[]} className='border-x-0 border-t-0 w-full text-gray-800 input-outline-none font-normal' style={{width: '200px'}}/>
              </Form.Item>
              <Form.Item label='Financial Account' name={'account_id'} className='font-semibold text-gray-800 mb-2 column' required>
                <Select options={accounts.map(account => ({value: account._id, ref: account.type, label: `${account.code} ${account.name}`}))} className='border-x-0 border-t-0 w-full text-gray-800 input-outline-none font-normal' style={{width: '200px'}}/>
              </Form.Item>
            </Col>
          </Row>
          
        </Form>
      </div>
    </div>
  )
}
export default AnalyticItemChanges;